import * as yup from 'yup';

const AddAutomationActionSchema = yup.object({
  reference: yup.string().required('Reference is required'),
});

export { AddAutomationActionSchema };
